module.exports = __webpack_public_path__ + "static/media/FacistBoard_small_4.36b83995.png";